import * as React from 'react';
import { pipe } from 'fp-ts/lib/function';
import * as L from 'monocle-ts/lib/Lens';


import { ErrorStatus } from '../../core/Input';


export interface FormContext {
    form: {
        [K: string]: {
            value: number | string | boolean,
            errorStatus: ErrorStatus,
        },
    },
    registry: (name: string) => void,
}

export interface FormProps {
    initialValue: {
        [K: string]: number | string | boolean
    }
}

const FormContext = React.createContext<FormContext>({
    form: {},
    registry: () => {
        console.warn('context not found registry');
    },
});

export const Form: React.FunctionComponent<FormProps> = ({ children, initialValue }) => {

    const instance: FormContext = React.useMemo(() => ({
        form: {},
        registry: (name: string) => {
            const value = initialValue[name];
            append(name, value);
        }
    }), []);

    return (
        <FormContext.Provider value={instance}>
            {children}
        </FormContext.Provider>
    );
}

export const useFormContext = () => {
    const ctx = React.useContext(FormContext);

    return ctx;
}

const z: ErrorStatus = 0;

export const append =
    (name: string, value: string | number | boolean) =>
        pipe(
            L.id<FormContext>(),
            L.prop('form'),
            L.modify(x => ({
                ...x,
                [name]: {
                    value,
                    errorStatus: z,
                }
            })),
        );
